module.exports = __webpack_public_path__ + "static/media/3.06fc4cf4.jpg";